









































import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { ILoginMerchant } from "@/types/interface/User/UserTypes";
import { yamimealLogo } from "../config/general";

@Component
export default class HeaderChips extends Vue {
  @Getter("merchant") merchant!: ILoginMerchant;
  @Getter("isPc") isPc!: boolean;
  public get logo(): string {
    return this.merchant.logo
      ? `${this.merchant.logo}?imageView2/2/w/80`
      : yamimealLogo;
  }

  public get showHistoryIcon(): boolean {
    if (this.$route.name === "Orders") {
      return true;
    }
    return false;
  }

  toHistory() {
    this.$router.push({ path: "history" });
  }
}
